import { createContext, useState } from 'react';
import useModal from 'src/services/modal';
import formatCurrency from 'src/util/formatCurrency';
import removePropsCurrencyFormat from 'src/util/removePropsCurrencyFormat';

const PropValAndTaxInfoContext = createContext();

export const PropValAndTaxInfoContextProvider = (props) => {
  const [assets, setAssets] = useState([]);
  const [editAsset, setEditAsset] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);

  const { display, handleClose, handleOpen } = useModal();

  const onRowClick = ({ row }) => {
    setEditAsset(true);

    setSelectedAsset(removePropsCurrencyFormat(row));

    handleOpen();
  };

  const closeAndReset = () => {
    handleClose();
    setEditAsset(false);
    setSelectedAsset(null);
  };

  const addAsset = ({ id, interest, penaltyFees, taxes, total, yearsOfDeliquency }) => {
    const newAsset = {
      id: id,
      interest: formatCurrency(interest),
      penaltyFees: formatCurrency(penaltyFees),
      taxes: formatCurrency(taxes),
      total: formatCurrency(total),
      yearsOfDeliquency: yearsOfDeliquency,
    };

    setAssets([...assets, newAsset]);
    closeAndReset();
  };

  const updateAsset = (updatedAsset) => {
    const index = assets.findIndex((obj) => obj.id == updatedAsset.id);
    const updatedAssets = [...assets];
    updatedAssets[index] = updatedAsset;
    setAssets(updatedAssets);
    setEditAsset(false);
    setSelectedAsset({});
    closeAndReset();
  };

  const deleteAsset = (assetToDelete) => {
    const index = assets.findIndex((obj) => obj.id == assetToDelete.id);
    const updatedAssets = [...assets];
    updatedAssets.splice(index, 1);
    setAssets(updatedAssets);
    closeAndReset();
  };

  const contextValue = {
    addAsset,
    assets,
    display,
    editAsset,
    handleOpen,
    onRowClick,
    selectedAsset,
    updateAsset,
    deleteAsset,
    closeAndReset,
  };

  return (
    <PropValAndTaxInfoContext.Provider value={contextValue}>
      {props.children}
    </PropValAndTaxInfoContext.Provider>
  );
};

export default PropValAndTaxInfoContext;
